// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Translation from "common/src/bindings/Translation.bs.js";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

function SetSelect(Props) {
  var set = Props.set;
  var setSet = Props.setSet;
  var t = Translation.useT(/* Common */0);
  return React.createElement(FormControl, {
              variant: "standard",
              children: null
            }, React.createElement(InputLabel, {
                  children: t("Set")
                }), React.createElement(Select, {
                  label: "Set",
                  value: set,
                  onChange: (function (e) {
                      var v = e.target.value;
                      return Curry._1(setSet, (function (param) {
                                    return v;
                                  }));
                    }),
                  className: "w-[80px]",
                  variant: "standard",
                  children: null
                }, React.createElement(MenuItem, {
                      value: /* Set18 */10,
                      children: t("Set #").replace("#", "18")
                    }), React.createElement(MenuItem, {
                      value: /* Set17 */9,
                      children: t("Set #").replace("#", "17")
                    }), React.createElement(MenuItem, {
                      value: /* Set16 */8,
                      children: t("Set #").replace("#", "16")
                    }), React.createElement(MenuItem, {
                      value: /* Set15 */7,
                      children: t("Set #").replace("#", "15")
                    }), React.createElement(MenuItem, {
                      value: /* Set14 */6,
                      children: t("Set #").replace("#", "14")
                    }), React.createElement(MenuItem, {
                      value: /* Set13 */5,
                      children: t("Set #").replace("#", "13")
                    }), React.createElement(MenuItem, {
                      value: /* Set46 */14,
                      children: t("Set #").replace("#", "4.5")
                    }), React.createElement(MenuItem, {
                      value: /* Set12 */4,
                      children: t("Set #").replace("#", "12")
                    }), React.createElement(MenuItem, {
                      value: /* Set11 */3,
                      children: t("Set #").replace("#", "11")
                    }), React.createElement(MenuItem, {
                      value: /* Set10 */2,
                      children: t("Set #").replace("#", "10")
                    }), React.createElement(MenuItem, {
                      value: /* Set36 */11,
                      children: t("Set #").replace("#", "3.5")
                    }), React.createElement(MenuItem, {
                      value: /* Set95 */1,
                      children: t("Set #").replace("#", "9.5")
                    }), React.createElement(MenuItem, {
                      value: /* Set9 */0,
                      children: t("Set #").replace("#", "9")
                    })));
}

var make = SetSelect;

export {
  make ,
  
}
/* react Not a pure module */
